/* eslint-disable no-prototype-builtins */
import axios from 'axios'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'

import { standardSpinner } from '../../../../helpers/spinners'
import { positionChangeWidthSm, promptsArray } from '../../../../helpers/variableDefaults'
import { descriptionTextField } from '../../../../helpers/textfields'
import { selectElementWithIndex } from '../../../../helpers/selects'
import { standardButton } from '../../../../helpers/buttons'
import { getTokenFromLocalStorage } from '../../../../helpers/storage'
import { standardErrorContainer } from '../../../../helpers/errors'
import { saveSuccessfulTypography, advisoryTypography } from '../../../../helpers/typographies'
import { titleAndAdvisoryJSX, saveAndCancelButtonsJSX, addBioItemIconButtonJSX, deleteBioItemIconButtonJSX, aboutMeElementsJSX } from '../../../../helpers/commonJSX'

export const aboutMeJSX = (
  bioObject, setBioObject,
  newAboutMe, setNewAboutMe,
  loadingAboutMe, setLoadingAboutMe,
  saveSuccessful, setSaveSuccessful,
  bioErrors, setBioErrors,
  width,
  isDemo
) => {

  const showSaveAndCancelButtons = () => {
    // console.log('newAboutMe.length > 0', newAboutMe.length > 0)
    // console.log('bioObject.aboutMe.length > 0', bioObject.aboutMe.length > 0)
    // console.log('lengths equal', newAboutMe.length === bioObject.aboutMe.length)
    // console.log('all indexes equal ->', bioObject.aboutMe.filter((aboutMeItem, index) => aboutMeItem !== newAboutMe[index]).length === 0)
    // console.log('bioObject.aboutMe[0] ->', bioObject.aboutMe[0])
    // console.log('newAboutMe[0] ->', newAboutMe[0])

    return !(
      newAboutMe.length > 0
      && bioObject.aboutMe.length > 0
      && newAboutMe.length === bioObject.aboutMe.length
      && bioObject.aboutMe.filter((aboutMeItem, index) => (index > newAboutMe.length) || (aboutMeItem !== newAboutMe[index])).length === 0
    )
  }

  const handleBioItemChange = (e, setErrors, setForm, form, index) => {
    e.preventDefault()

    setBioErrors({ ...bioErrors, aboutMe: false })
    setSaveSuccessful({ ...saveSuccessful, aboutMe: false })

    const { name, value } = e.target
    // console.log('name ->', name)
    // console.log('value ->', value)
    // console.log('index ->', index)

    if (name === 'aboutMe' && value !== ' ') {
      let updatedAboutMe = [ ...newAboutMe ]
      updatedAboutMe[index] = value
      // console.log('multiple blanks ->', updatedAboutMe.filter(aboutMeItem => aboutMeItem.trim().length === 0).length)
      if (
        value === ''
        && updatedAboutMe.filter(aboutMeItem => aboutMeItem.trim().length === 0).length > 1
      ) {
        // console.log('this runs')
        updatedAboutMe = updatedAboutMe.length === updatedAboutMe.filter(aboutMeItem => aboutMeItem.trim().length === 0).length ? [''] : [ ...updatedAboutMe.filter(aboutMeItem => aboutMeItem.trim().length > 0), '']
      }
      setForm([ ...updatedAboutMe ])
    } 
  }

  // Add Bio Item JSX
  const addBioItemJSX = (itemType, disabled) => {

    const handleAddItem = () => {
      if (itemType === 'aboutMe') {

        setBioErrors({ ...bioErrors, aboutMe: false })
        setSaveSuccessful({ ...saveSuccessful, aboutMe: false })

        const updatedAboutMe = [ ...newAboutMe, '' ]
        setNewAboutMe([ ...updatedAboutMe ])
      } 
    }

    return (
      <>
        {addBioItemIconButtonJSX(handleAddItem, disabled)}
      </>
    )
  }

  // Delete Bio Item JSX
  const deleteBioItemJSX = (itemType, index, disabled = false) => {

    const handleDeleteBioItem = (e) => {
      e.preventDefault()

      if (!disabled) {
        setBioErrors({ ...bioErrors, aboutMe: false })
        setSaveSuccessful({ ...saveSuccessful, aboutMe: false })

        if (itemType === 'aboutMe') {
          const updatedAboutMe = [ ...newAboutMe.filter((x, i) => i !== index) ]
          setNewAboutMe([ ...updatedAboutMe ])
        } 
      }
    }

    return (
      <>
        {deleteBioItemIconButtonJSX(disabled, handleDeleteBioItem, width)}
      </>
    )
  }

  const handleCancelPressed = () => {
    // console.log('handleCancelPressed runs')
    setBioErrors({ ...bioErrors, aboutMe: false })
    setSaveSuccessful({ ...saveSuccessful, aboutMe: false })

    setNewAboutMe([ ...bioObject.aboutMe ])
  }

  const handleSavePressed = async () => {
    console.log('handleSavePressed runs')
    const objectToUpload = {
      aboutMe: [ ...newAboutMe ],
    }
    // console.log('objectToUpload ->', objectToUpload)
    // console.log('objectToUpload.aboutMe.length > 0 ->', objectToUpload.aboutMe.length > 0)
    // console.log('lengths are equal ->', objectToUpload.aboutMe.length === bioObject.aboutMe.length)
    // console.log('arrays are different ->', !(objectToUpload.aboutMe.length === bioObject.aboutMe.length && bioObject.aboutMe.filter((aboutMeItem, index) => aboutMeItem !== objectToUpload.aboutMe[index]).length === 0))

    // Upload Modifications
    if (isDemo) {
      setBioObject({ ...bioObject, aboutMe: [ ...objectToUpload.aboutMe ] })
      setSaveSuccessful({ ...saveSuccessful, aboutMe: true })
    } else if (objectToUpload.aboutMe.length > 0 
      && 
      !(
        objectToUpload.aboutMe.length === bioObject.aboutMe.length
        && bioObject.aboutMe.filter((aboutMeItem, index) => aboutMeItem !== objectToUpload.aboutMe[index]).length === 0
      )
    ) {
      // console.log('attempting upload aboutMe')
      setLoadingAboutMe(true)
      setBioErrors({ ...bioErrors, aboutMe: false })
      setSaveSuccessful({ ...saveSuccessful, aboutMe: false })
      
      try {
        // PUT request with updated profile object
        // await axios.put(`/api/users/${userId}`, newForm, {
        await axios.put(`${process.env.REACT_APP_SERVER_URL}/api/bio-items/${bioObject._id}`, objectToUpload, {
          headers: {
            Authorization: `Bearer ${getTokenFromLocalStorage()}`,
          },
        })

        setBioObject({ ...bioObject, aboutMe: [ ...objectToUpload.aboutMe ] })

        setBioErrors({ ...bioErrors, aboutMe: false })
        setSaveSuccessful({ ...saveSuccessful, aboutMe: true })
        setLoadingAboutMe(false)
        
      } catch (error) {
        console.log(error)
        setBioErrors({ ...bioErrors, aboutMe: true })
        setSaveSuccessful({ ...saveSuccessful, aboutMe: false })
        setLoadingAboutMe(false)
      }
    }
  }

  // About Me JSX
  const aboutMeJSX = () => {
    return (
      <>
        {aboutMeElementsJSX(newAboutMe, deleteBioItemJSX, handleBioItemChange, setBioErrors, newAboutMe, setNewAboutMe )}
      </>
    )
  }

  return (
    <Box
      sx={{
        py: 3, my: 3,
        width: '90%',
        maxWidth: '600px',
        backgroundColor: showSaveAndCancelButtons() ? 'lightgray' : 'whitesmoke',
        borderRadius: 3, boxShadow: 3,
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: '90%',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >
        {/* About Me Section */}
        {/* Title and Advisory JSX */}
        {titleAndAdvisoryJSX(
          'About Me', 
          '*Up to 3 long-form bios',
          0
        )}

        {/* About Me JSX */}
        {aboutMeJSX()}

        {/* Add About Me Button */}
        {addBioItemJSX(
          'aboutMe',
          (
            newAboutMe.length > 2 
            || newAboutMe.filter(aboutMeItem => aboutMeItem.trim().length === 0).length > 0
            || loadingAboutMe
          )
        )}

        {/* Save and Cancel Buttons */}
        {showSaveAndCancelButtons() &&
          saveAndCancelButtonsJSX(
            loadingAboutMe,
            (!(showSaveAndCancelButtons()) || loadingAboutMe),
            handleCancelPressed,
            handleSavePressed,
            0,
            bioErrors.aboutMe ? 0 : 2,
            2,
            'warning',
            'primary'
          )
        }

        {/* Loading */}
        {loadingAboutMe &&
          advisoryTypography(`Uploading Changes...`, 'center')
        }

        {/* Error Message */}
        {bioErrors.aboutMe &&
          standardErrorContainer(`There was an error uploading the changes. Check your Internet connection and try again.`)
        }

        {/* Save Successful */}
        {saveSuccessful.aboutMe &&
          saveSuccessfulTypography()
        }
      </Box>
    </Box>
  )
}